<div class="so-modal">
    <div class="so-modal-body">
        <ng-content></ng-content>
    </div>
</div>